// import React, { useState } from "react";

// // Hardcoded Data exactly from the screenshots
// const PROMPT_CATEGORIES = [
//   {
//     id: "kb-intelligence",
//     title: "Knowledge Base Intelligence & Search",
//     icon: (
//       <svg
//         className="w-5 h-5"
//         fill="none"
//         stroke="currentColor"
//         viewBox="0 0 24 24"
//       >
//         <path
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           strokeWidth="2"
//           d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
//         />
//       </svg>
//     ),
//     prompts: [
//       {
//         title: "Semantic Knowledge Search",
//         description:
//           "Search the knowledge base for semantically related information on this topic, not just keyword matches.",
//         tags: ["Knowledge Base", "Automation", "Search", "Analysis"],
//       },
//       {
//         title: "Contextual Information Finder",
//         description:
//           "Find contextually relevant documents, decisions, and insights related to this request.",
//         tags: ["Strategy", "Knowledge Base", "Search"],
//       },
//       {
//         title: "Intelligent Folder Mapping",
//         description:
//           "Recommend an optimized folder structure for organizing this knowledge base.",
//         tags: ["Automation", "Documentation", "Knowledge Base"],
//       },
//     ],
//   },
//   {
//     id: "doc-intelligence",
//     title: "Document Intelligence & Understanding",
//     icon: (
//       <svg
//         className="w-5 h-5"
//         fill="none"
//         stroke="currentColor"
//         viewBox="0 0 24 24"
//       >
//         <path
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           strokeWidth="2"
//           d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//         />
//       </svg>
//     ),
//     prompts: [
//       {
//         title: "Smart Document Analyzer",
//         description:
//           "Analyze this document and extract objectives, risks, dependencies, and business relevance.",
//         tags: ["Knowledge Base", "Automation", "Documentation", "Analysis"],
//       },
//       {
//         title: "Clause & Policy Interpreter",
//         description:
//           "Interpret complex clauses, policies, and rules into simplified operational guidance.",
//         tags: [
//           "Risk Managing",
//           "Knowledge Base",
//           "Documentation",
//           "Compliance",
//         ],
//       },
//       {
//         title: "Knowledge Standardizer",
//         description:
//           "Standardize this document into the organization's knowledge format.",
//         tags: ["Automation", "Documentation", "Knowledge Base"],
//       },
//       {
//         title: "Multi-Document Synthesizer",
//         description:
//           "Combine insights from multiple documents into one unified knowledge view.",
//         tags: ["Analysis", "Knowledge Base", "Documentation"],
//       },
//     ],
//   },
//   {
//     id: "strategy-governance",
//     title: "Strategy, Governance & Decision Intelligence",
//     icon: (
//       <svg
//         className="w-5 h-5"
//         fill="none"
//         stroke="currentColor"
//         viewBox="0 0 24 24"
//       >
//         <path
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           strokeWidth="2"
//           d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
//         />
//       </svg>
//     ),
//     prompts: [
//       {
//         title: "Knowledge-Based Decision Support",
//         description:
//           "Support this decision using historical data, documents, and organizational knowledge.",
//         tags: ["Knowledge Base", "Risk Managing"],
//       },
//       {
//         title: "Governance Intelligence Tool",
//         description:
//           "Analyze governance risks, compliance gaps, and control weaknesses.",
//         tags: ["Risk Managing", "Knowledge Base", "Compliance"],
//       },
//       {
//         title: "Strategic Knowledge Planner",
//         description:
//           "Build a strategic knowledge roadmap for this business domain stated below.",
//         tags: ["Knowledge Base", "Analysis"],
//       },
//     ],
//   },
// ];

// const PromptLibraryModal = ({ onClose, onSelectPrompt }) => {
//   const [activeCategoryId, setActiveCategoryId] = useState("all");
//   const [searchQuery, setSearchQuery] = useState("");

//   const isSpecificCategoryActive = activeCategoryId !== "all";
//   const activeCategory = PROMPT_CATEGORIES.find(
//     (c) => c.id === activeCategoryId
//   );

//   return (
//     <div className="fixed inset-0 bg-black/40 z-[100] flex items-center justify-center p-4">
//       <div className="bg-white rounded-[16px] w-full max-w-[900px] max-h-[85vh] flex flex-col shadow-2xl overflow-hidden font-outfit">
//         {/* Header */}
//         <div className="px-6 py-5 flex items-center justify-between flex-shrink-0">
//           {isSpecificCategoryActive ? (
//             <button
//               onClick={() => setActiveCategoryId("all")}
//               className="flex items-center gap-2 text-[#3F3F46] hover:text-black font-semibold text-lg transition-colors"
//             >
//               <svg
//                 className="w-5 h-5"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//                 strokeWidth="2.5"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   d="M15 19l-7-7 7-7"
//                 />
//               </svg>
//               {activeCategory?.title}
//             </button>
//           ) : (
//             <h2 className="text-xl font-semibold text-[#3F3F46]">
//               Prompt Library
//             </h2>
//           )}
//           <button
//             onClick={onClose}
//             className="text-gray-500 hover:text-black transition-colors p-1"
//           >
//             <svg
//               className="w-5 h-5"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//               strokeWidth="2.5"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             </svg>
//           </button>
//         </div>

//         {/* Scrollable Body */}
//         <div className="flex-1 overflow-y-auto px-6 py-2 custom-scrollbar bg-white">
//           {/* Main View Top Inputs */}
//           {!isSpecificCategoryActive && (
//             <div className="flex gap-4 mb-8">
//               {/* Text Search Input */}
//               {/* Text Search Input */}
//               <div className="flex-1 flex items-center bg-[#F9FAFB] border border-gray-200 rounded-lg px-3 py-2.5 shadow-sm">
//                 <svg
//                   className="w-[16px] h-[16px] text-[#3F3F46] flex-shrink-0"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                   />
//                 </svg>
//                 <input
//                   type="text"
//                   placeholder="Search a prompt..."
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   className="bg-transparent h-5 border-none outline-none font-medium hover:text-[14px] text-[14px] w-full ml-2 text-[#3F3F46] placeholder-gray-500"
//                   style={{ fontSize: "14px", lineHeight: "20px" }}
//                 />
//               </div>

//               {/* Category Dropdown Filter */}
//               <select
//                 value={activeCategoryId}
//                 onChange={(e) => setActiveCategoryId(e.target.value)}
//                 className="bg-[#F9FAFB] border border-gray-200 rounded-lg px-4 py-2.5 text-[14px] text-[#4B5563] shadow-sm outline-none cursor-pointer min-w-[200px]"
//               >
//                 <option value="all">All Categories</option>
//                 {PROMPT_CATEGORIES.map((c) => (
//                   <option key={c.id} value={c.id}>
//                     {c.title}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           )}

//           {/* Categories & Cards Rendering */}
//           <div className="flex flex-col gap-10 pb-8">
//             {(isSpecificCategoryActive
//               ? [activeCategory]
//               : PROMPT_CATEGORIES
//             ).map((category) => {
//               if (!category) return null;

//               // Filter out cards based on search query
//               const filteredPrompts = category.prompts.filter(
//                 (p) =>
//                   p.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                   p.description
//                     .toLowerCase()
//                     .includes(searchQuery.toLowerCase())
//               );

//               // Don't render category if no prompts match the text search
//               if (filteredPrompts.length === 0) return null;

//               // Display 2 cards in Main View (unless searching), Display All inside "View All" or when searching
//               const isSearching = searchQuery.trim().length > 0;
//               const displayPrompts =
//                 isSpecificCategoryActive || isSearching
//                   ? filteredPrompts
//                   : filteredPrompts.slice(0, 2);

//               return (
//                 <div key={category.id} className="flex flex-col">
//                   {!isSpecificCategoryActive && (
//                     <div className="flex items-center justify-between mb-4 border-b border-gray-100 pb-2">
//                       <div className="flex items-center gap-2 text-[#BB42AE]">
//                         <div className="w-[30px] h-[30px] rounded-full bg-[#F6E8F6] flex items-center justify-center text-[#BB42AE]">
//                           {category.icon}
//                         </div>
//                         <h3 className="text-[16px] font-medium">
//                           {category.title}
//                         </h3>
//                       </div>

//                       {/* Show View All if there are more than 2 items and user isn't searching */}
//                       {filteredPrompts.length > 2 && !isSearching && (
//                         <button
//                           onClick={() => setActiveCategoryId(category.id)}
//                           className="text-[13px] text-gray-500 hover:text-gray-900 font-semibold underline decoration-gray-300 underline-offset-4 transition-colors"
//                         >
//                           View All
//                         </button>
//                       )}
//                     </div>
//                   )}

//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     {displayPrompts.map((prompt, idx) => (
//                       <div
//                         key={idx}
//                         onClick={() => onSelectPrompt(prompt.description)}
//                         className="rounded-[8px] border bg-[#FCFCFC] hover:shadow-[0_2px_2px_-0.5px_rgba(0,0,0,0.1),0_2px_2px_-0.5px_rgba(0,0,0,0.05)] bg-white p-5 hover:border-border-black/25 border-gray-200 transition-all cursor-pointer flex flex-col justify-between"
//                       >
//                         <div>
//                           <h4 className="text-[15px] font-semibold text-[#000000B3] mb-2">
//                             {prompt.title}
//                           </h4>
//                           <p className="text-[13.5px] font-normal text-[#000000B3] leading-relaxed mb-6">
//                             {prompt.description}
//                           </p>
//                         </div>
//                         <div className="flex flex-wrap gap-2">
//                           {prompt.tags.map((tag, tagIdx) => (
//                             <span
//                               key={tagIdx}
//                               className="bg-[#E7E7E7] text-[#00000099] text-[11.5px] font-medium px-2.5 py-1 rounded-md"
//                             >
//                               {tag}
//                             </span>
//                           ))}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               );
//             })}

//             {/* Empty State when search yields no results across all categories */}
//             {!isSpecificCategoryActive &&
//               PROMPT_CATEGORIES.every(
//                 (c) =>
//                   c.prompts.filter(
//                     (p) =>
//                       p.title
//                         .toLowerCase()
//                         .includes(searchQuery.toLowerCase()) ||
//                       p.description
//                         .toLowerCase()
//                         .includes(searchQuery.toLowerCase())
//                   ).length === 0
//               ) && (
//                 <div className="text-center py-10 text-gray-500">
//                   No prompts found matching "{searchQuery}"
//                 </div>
//               )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PromptLibraryModal;
import React, { useState } from "react";

// Hardcoded Data exactly from the screenshots
const PROMPT_CATEGORIES = [
  {
    id: "kb-intelligence",
    title: "Knowledge Base Intelligence & Search",
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
        />
      </svg>
    ),
    prompts: [
      {
        title: "Semantic Knowledge Search",
        description:
          "Search the knowledge base for semantically related information on this topic, not just keyword matches.",
        tags: ["Knowledge Base", "Automation", "Search", "Analysis"],
      },
      {
        title: "Contextual Information Finder",
        description:
          "Find contextually relevant documents, decisions, and insights related to this request.",
        tags: ["Strategy", "Knowledge Base", "Search"],
      },
      {
        title: "Intelligent Folder Mapping",
        description:
          "Recommend an optimized folder structure for organizing this knowledge base.",
        tags: ["Automation", "Documentation", "Knowledge Base"],
      },
    ],
  },
  {
    id: "doc-intelligence",
    title: "Document Intelligence & Understanding",
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    ),
    prompts: [
      {
        title: "Smart Document Analyzer",
        description:
          "Analyze this document and extract objectives, risks, dependencies, and business relevance.",
        tags: ["Knowledge Base", "Automation", "Documentation", "Analysis"],
      },
      {
        title: "Clause & Policy Interpreter",
        description:
          "Interpret complex clauses, policies, and rules into simplified operational guidance.",
        tags: [
          "Risk Managing",
          "Knowledge Base",
          "Documentation",
          "Compliance",
        ],
      },
      {
        title: "Knowledge Standardizer",
        description:
          "Standardize this document into the organization's knowledge format.",
        tags: ["Automation", "Documentation", "Knowledge Base"],
      },
      {
        title: "Multi-Document Synthesizer",
        description:
          "Combine insights from multiple documents into one unified knowledge view.",
        tags: ["Analysis", "Knowledge Base", "Documentation"],
      },
    ],
  },
  {
    id: "strategy-governance",
    title: "Strategy, Governance & Decision Intelligence",
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
        />
      </svg>
    ),
    prompts: [
      {
        title: "Knowledge-Based Decision Support",
        description:
          "Support this decision using historical data, documents, and organizational knowledge.",
        tags: ["Knowledge Base", "Risk Managing"],
      },
      {
        title: "Governance Intelligence Tool",
        description:
          "Analyze governance risks, compliance gaps, and control weaknesses.",
        tags: ["Risk Managing", "Knowledge Base", "Compliance"],
      },
      {
        title: "Strategic Knowledge Planner",
        description:
          "Build a strategic knowledge roadmap for this business domain stated below.",
        tags: ["Knowledge Base", "Analysis"],
      },
    ],
  },
];

const PromptLibraryModal = ({ onClose, onSelectPrompt }) => {
  const [activeCategoryId, setActiveCategoryId] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const isSpecificCategoryActive = activeCategoryId !== "all";
  const activeCategory = PROMPT_CATEGORIES.find(
    (c) => c.id === activeCategoryId
  );

  return (
    <div className="fixed inset-0 bg-black/40 z-[100] flex items-center justify-center p-4">
      <div className="bg-white rounded-[16px] w-full max-w-[900px] max-h-[85vh] flex flex-col shadow-2xl overflow-hidden font-outfit">
        {/* Header */}
        <div className="px-6 py-5 flex items-center justify-between flex-shrink-0">
          {isSpecificCategoryActive ? (
            <button
              onClick={() => setActiveCategoryId("all")}
              className="flex items-center gap-2 text-[#3F3F46] hover:text-black font-semibold text-lg transition-colors"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2.5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              {activeCategory?.title}
            </button>
          ) : (
            <h2 className="text-xl font-semibold text-[#3F3F46]">
              Prompt Library
            </h2>
          )}
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black transition-colors p-1"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2.5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Fixed Search & Filter Section */}
        {!isSpecificCategoryActive && (
          <div className="px-6 pb-6 flex gap-4 flex-shrink-0 bg-white">
            {/* Text Search Input */}
            <div className="flex-1 flex items-center bg-[#F9FAFB] border border-gray-200 rounded-lg px-3 py-2.5 shadow-sm">
              <svg
                className="w-[16px] h-[16px] text-[#3F3F46] flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              <input
                type="text"
                placeholder="Search a prompt..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="bg-transparent h-5 border-none outline-none font-medium hover:text-[14px] text-[14px] w-full ml-2 text-[#3F3F46] placeholder-gray-500"
                style={{ fontSize: "14px", lineHeight: "20px" }}
              />
            </div>

            {/* Category Dropdown Filter */}
            <select
              value={activeCategoryId}
              onChange={(e) => setActiveCategoryId(e.target.value)}
              className="bg-[#F9FAFB] border border-gray-200 rounded-lg px-4 py-2.5 text-[14px] text-[#4B5563] shadow-sm outline-none cursor-pointer min-w-[200px]"
            >
              <option value="all">All Categories</option>
              {PROMPT_CATEGORIES.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.title}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Scrollable Body */}
        <div className="flex-1 overflow-y-auto px-6 py-2 custom-scrollbar bg-white">
          {/* Categories & Cards Rendering */}
          <div className="flex flex-col gap-10 pb-8">
            {(isSpecificCategoryActive
              ? [activeCategory]
              : PROMPT_CATEGORIES
            ).map((category) => {
              if (!category) return null;

              // Filter out cards based on search query
              const filteredPrompts = category.prompts.filter(
                (p) =>
                  p.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                  p.description
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
              );

              // Don't render category if no prompts match the text search
              if (filteredPrompts.length === 0) return null;

              // Display 2 cards in Main View (unless searching), Display All inside "View All" or when searching
              const isSearching = searchQuery.trim().length > 0;
              const displayPrompts =
                isSpecificCategoryActive || isSearching
                  ? filteredPrompts
                  : filteredPrompts.slice(0, 2);

              return (
                <div key={category.id} className="flex flex-col">
                  {!isSpecificCategoryActive && (
                    <div className="flex items-center justify-between mb-4 border-b border-gray-100 pb-2">
                      <div className="flex items-center gap-2 text-[#BB42AE]">
                        <div className="w-[30px] h-[30px] rounded-full bg-[#F6E8F6] flex items-center justify-center text-[#BB42AE]">
                          {category.icon}
                        </div>
                        <h3 className="text-[16px] font-medium">
                          {category.title}
                        </h3>
                      </div>

                      {/* Show View All if there are more than 2 items and user isn't searching */}
                      {filteredPrompts.length > 2 && !isSearching && (
                        <button
                          onClick={() => setActiveCategoryId(category.id)}
                          className="text-[13px] text-gray-500 hover:text-gray-900 font-semibold underline decoration-gray-300 underline-offset-4 transition-colors"
                        >
                          View All
                        </button>
                      )}
                    </div>
                  )}

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {displayPrompts.map((prompt, idx) => (
                      <div
                        key={idx}
                        onClick={() => onSelectPrompt(prompt.description)}
                        className="rounded-[8px] border bg-[#FCFCFC] hover:shadow-[0_2px_2px_-0.5px_rgba(0,0,0,0.1),0_2px_2px_-0.5px_rgba(0,0,0,0.05)] bg-white p-5 hover:border-border-black/25 border-gray-200 transition-all cursor-pointer flex flex-col justify-between"
                      >
                        <div>
                          <h4 className="text-[15px] font-semibold text-[#000000B3] mb-2">
                            {prompt.title}
                          </h4>
                          <p className="text-[13.5px] font-normal text-[#000000B3] leading-relaxed mb-6">
                            {prompt.description}
                          </p>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          {prompt.tags.map((tag, tagIdx) => (
                            <span
                              key={tagIdx}
                              className="bg-[#E7E7E7] text-[#00000099] text-[11.5px] font-medium px-2.5 py-1 rounded-md"
                            >
                              {tag}
                            </span>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}

            {/* Empty State when search yields no results across all categories */}
            {!isSpecificCategoryActive &&
              PROMPT_CATEGORIES.every(
                (c) =>
                  c.prompts.filter(
                    (p) =>
                      p.title
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase()) ||
                      p.description
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
                  ).length === 0
              ) && (
                <div className="text-center py-10 text-gray-500">
                  No prompts found matching "{searchQuery}"
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptLibraryModal;
